import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { handleErrorToast } from '../../../../shared/Functions';
import { FormController } from '../../../../shared/FormController';
import { $BillingAccountACHTokenCreateDTO, TokensVService } from '../../../../../services/V2/gozer';


export function ACHPayment({ billingAccountId, step, setStep, failureCallback, handleAdd, formData, setFormData, setStepName }) {
    const [achTokens, setACHTokens] = useState<any[]>([]);
    const [model, setModel] = useState<any>({});
    const [tokenId, setTokenId] = useState<string>("");

    useEffect(() => {
        TokensVService.tokensVGetAll(billingAccountId)
            .then(t => setACHTokens(t))
            .catch(err => failureCallback(handleErrorToast(err)));
    }, [billingAccountId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(step === 2 && formData.paymentMethod !== "NEW") {
            if(!formData.paymentAmount || !formData.paymentMethod){
                failureCallback("Payment Amount and Payment Method are both required.");
                setStep(1)
            } else {
                handleAdd();
            }
        } else if (step === 2 && formData.paymentMethod === "NEW"){
            if(!formData.paymentAmount || !formData.paymentMethod){
                failureCallback("Payment Amount and Payment Method are both required.");
                setStep(1)
            } else {
                setStepName("Process Payment");
            }
        } else if(step === 3) {
            let addModel = {
                nickName: model.nickName,
                bankName: model.bankName,
                achType: model.achType,
                achAccountHolderType: model.achAccountHolderType,
                achAccount: model.achAccount,
                achRouting: model.achRouting,
                firstName: model.firstName,
                lastName: model.lastName,
                streetAddress: model.streetAddress,
                city: model.city,
                state: model.state,
                zip: model.zip,
                isSaved: formData.savePayment ?? false,
            };
            TokensVService.tokensVCreateAch (billingAccountId, addModel)
                .then(res => {
                    setFormData({
                        ...formData,
                        paymentMethod: {
                            id: res?.id
                        }
                    });
                    setTokenId(res?.id ?? "");
                })
                .catch(err => failureCallback(handleErrorToast(err)));
        }
    }, [step])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(tokenId !== ""){
            setStepName("");
            setStep(3);
            handleAdd();
        }
    }, [tokenId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(formData.paymentMethod && formData.paymentMethod !== "NEW"){
            setStepName("Process Payment")
        } else if(formData.paymentMethod && formData.paymentMethod === "NEW" && step !== 3){
            setStepName("Continue")
        }
    }, [formData])// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = event => {
        let name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        }

        setFormData({
            ...formData,
            [name]: value
        })
    }

    return (
        <>
            {step === 1 &&
                <>
                    <TextField
                        onChange={handleChange}
                        required={true}
                        margin="normal"
                        name="paymentAmount"
                        label="Payment Amount"
                        type="text"
                        value={formData === undefined ? null : formData.paymentAmount}
                        fullWidth
                    />
                    <TextField style={{ width: '100%', textAlign: 'left' }}
                        required={true}
                        select
                        onChange={handleChange}
                        margin="normal"
                        name="paymentMethod"
                        label="Payment Method"
                        type="string"
                        value={formData === undefined || formData.paymentMethod === undefined ? "" : formData.paymentMethod}
                        >
                            <option value="NEW">New Payment Method</option>
                            {
                                achTokens.map(t => (
                                    <option key={t.id} value={t}>
                                        {`${t.bankName} ${t.achType} ${t.last4}`}
                                    </option>
                                ))
                            }
                    </TextField>
                    {formData.paymentMethod === "NEW" &&
                        <FormControlLabel style={{ margin:'0px' }}
                            label="Save For Future Use"
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={(formData === undefined
                                        || formData === null || formData.savePayment === undefined ? false : formData.savePayment)}
                                    onChange={handleChange}
                                    color="primary"
                                    name="savePayment" />
                        } />
                    }
                    {formData.savePayment === true &&
                        <FormControlLabel style={{ margin:'0px' }}
                            label="Use For Autopay"
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={(formData === undefined
                                        || formData === null || formData.autopay === undefined ? false : formData.autopay)}
                                    onChange={handleChange}
                                    color="primary"
                                    name="autopay" />
                        } />
                    }
                </>
            }
            {step === 2 && formData.paymentMethod === "NEW" &&
                <FormController
                    keys={$BillingAccountACHTokenCreateDTO.properties}
                    disabledKeys={[]}
                    extraKeys={[]}
                    editMode={true}
                    model={model}
                    setModel={setModel}
                    canReadUserRoles={false}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null} />
            }
            {step === 3 &&
                <>
                </>
            }
        </>
    );
}